import React from "react";
import {useAdmission} from "~/apps/packages/passes/hooks";
import {useHistory, useParams} from "react-router-dom";
import { AdmissionDetail } from "./AdmissionDetail";
import {TitleLayout} from "~/apps/core/ui/TitleLayout";
import {Box} from "@mui/system";
import {FloatingActions} from "~/apps/core/ui/FloatingActions";
import {Button} from "@mui/material";
import {getLocationForCreateAdmission} from "~/apps/packages/passes/components/CreatePage";
import { LoadingBox } from "~/apps/core/ui/LoadingBox";
import {Admission} from "~/queries";


export const DetailPage = () => {
    const history = useHistory();
    const {id} = useParams<{ id: string }>();
    const {data, loading} = useAdmission(id);

    const handleRepeatClick = () => {
        history.push(getLocationForCreateAdmission({...data, passDate: null, isRepeating: true} as Partial<Admission>))
    }

    return (
        <TitleLayout title="Заявка на пропуск">
            <LoadingBox loading={loading}>
                {data && (
                    <>
                        <Box pt={2} pb={2}>
                            <AdmissionDetail admission={data}/>
                        </Box>
                        <Box minHeight="80px"/>
                        <FloatingActions>
                            <Button onClick={handleRepeatClick}
                                    fullWidth
                                    color="primary"
                            >
                                Повторить
                            </Button>
                        </FloatingActions>
                    </>
                )}
            </LoadingBox>
        </TitleLayout>
    );
}
